import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavController, PopoverController } from '@ionic/angular';
import { UserService } from 'octali-lib-firebase-utils';
import { DisplayerService } from 'octali-lib-utils';
import { LoginPage } from 'src/app/pages/user/login/login.page';

@Component({
  selector: 'app-account-popover',
  templateUrl: './account-popover.component.html',
  styleUrls: ['./account-popover.component.scss'],
})
export class AccountPopoverComponent implements OnInit {

  public connected:boolean = false;
  
  
  constructor(
    private profileService:UserService,
    private router:Router,
    private popover:PopoverController,
    private displayer:DisplayerService,
    private navCtrl: NavController
  ) { 
    this.connected = false;
    this.profileService.getUser().subscribe(profile=> {
      if(profile){
        if(profile.isAnonym)
          this.connected = false;
        else
          this.connected = true;
      } else 
        this.connected = false;
    });
  }

  ngOnInit() {}

  ngOnDestroy() {
    
  }
  login() {
    //this.router.navigate(['/user/account/login',{ urlReturn: window.location.pathname }]);
    this.displayer.presentModal(LoginPage);
    this.popover.dismiss();
  }

  seePage(page){
    this.navCtrl.navigateRoot(page)
    this.popover.dismiss();
  }

  async logOut(){
    this.popover.dismiss();
    this.router.navigate(['accueil']);
    await this.profileService.logout();
    await this.displayer.dismissLoader();
  }

}
